module.exports = __webpack_public_path__ + "static/media/collab.3ee545cd.svg";